var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoaderArrowRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 21,
    viewBox: "0 0 12 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.20008 0H0.618652L6.20826 10.0551L0.618652 20.1102H6.20008L11.8551 10.0551L6.20008 0Z",
    fill: "#E60033"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderArrowRed);
export default __webpack_public_path__ + "static/media/loader_arrow_red.0e8fd60c4ee385f6e4c72211647bdd04.svg";
export { ForwardRef as ReactComponent };